import classNames from 'classnames'
import { useEffect, useState } from 'react'
import { useActions, useAppSelector } from 'store/hooks'
import { Button } from 'ui'

import style from './ConfirmCounter.module.scss'

export type CounterProps = {
  startTimerPosition: number
  onReRequestSms: () => void
  whenZero?: () => void
  inputRefs: React.MutableRefObject<HTMLInputElement[]>
}

// счетчик для смс сообщений (для повторной отправки)
export function ConfirmCounter({
  startTimerPosition,
  onReRequestSms,
  whenZero,
  inputRefs,
}: CounterProps) {
  const [count, setCount] = useState<number>(0)

  const { smsInfo } = useAppSelector(state => state.auth)
  const { setSmsInfo } = useActions()

  useEffect(() => {
    if (smsInfo.blockTime !== 0) setCount(smsInfo.blockTime)
    else setCount(startTimerPosition)
  }, [startTimerPosition])

  useEffect(() => {
    const timer = setInterval(() => {
      if (count > 0) {
        setCount(prev => prev - 1)
        setSmsInfo({ blockTime: count - 1 })
      }
      if (count === 1 && whenZero) whenZero()
    }, 1000)

    return () => clearInterval(timer)
  }, [count])

  const getSmsHandler = () => {
    setCount(startTimerPosition)
    onReRequestSms()
    inputRefs.current[0].focus()
  }

  const minutes = Math.floor(count / 60)
  const seconds = count - minutes * 60

  return (
    <div className={classNames(style.getNewCode, 'mt24')}>
      <Button
        onClick={getSmsHandler}
        disabled={count > 0}
        data-testid='sms-resend-button'
      >
        {count === 0 && <p>Получить новый код</p>}
        {count > 0 && (
          <>
            <span>Получить новый код через</span>
            <span className={style.time}>
              {`${String(minutes).length === 1 ? `0${minutes}` : minutes}:${
                String(seconds).length === 1 ? `0${seconds}` : seconds
              }`}
            </span>
          </>
        )}
      </Button>
    </div>
  )
}
